import React, { useCallback } from "react";
import styles from "./styles.module.css";
import TickerSearch, {
  type DropdownOptions,
} from "~components/Portfolio/TickerSearch";

const MAX_COMPARISON_TICKERS = 4;

interface ComparisonTickerSearchProps {
  readonly searchURL: string;
  readonly countryCode?: string;
  readonly comparisonTickers: string[];
  readonly primaryTicker?: string;
  readonly maxTickers?: number;
  readonly onAdd: (tickerId: string) => void;
}

export default function ComparisonTickerSearch({
  searchURL,
  countryCode,
  comparisonTickers,
  primaryTicker,
  maxTickers = MAX_COMPARISON_TICKERS,
  onAdd,
}: ComparisonTickerSearchProps) {
  const isAtMax = comparisonTickers.length >= maxTickers;

  const handleChange = useCallback(
    (
      value: DropdownOptions[0] | null,
      downshiftHandle: { setState: (value: unknown) => void }
    ) => {
      const tickerId = value?.value;

      if (!tickerId) return;

      const upperTickerId = tickerId.toUpperCase();
      const isDuplicate =
        comparisonTickers.some((t) => t.toUpperCase() === upperTickerId) ||
        primaryTicker?.toUpperCase() === upperTickerId;

      if (!isDuplicate) {
        onAdd(upperTickerId);
      }

      downshiftHandle.setState({ inputValue: "" });
    },
    [comparisonTickers, primaryTicker, onAdd]
  );

  return (
    <TickerSearch
      searchURL={searchURL}
      countryCode={countryCode}
      className={styles.comparisonSearch}
      disabled={isAtMax}
      placeholder={isAtMax ? "Max comparisons reached" : "Add a comparison"}
      onChange={handleChange}
    />
  );
}
